import React, { useEffect, useState } from "react";
import SideBar from "./SideBar";
import Header from "./Header";
import { SlHome } from "react-icons/sl";
import { SlArrowRight } from "react-icons/sl";
import { getUserSearchCreateAPI } from "../../serverApi/server";
import moment from "moment-timezone";

const SearchUserList = () => {
    const [searchUserDetails, setSearchUserDetails] = useState([])
    const getUserSearchCreatDetails = async () => {
        const getUserSearchCreateAPIResponse = await getUserSearchCreateAPI()
        if (getUserSearchCreateAPIResponse && getUserSearchCreateAPIResponse.data && getUserSearchCreateAPIResponse.data.client_status_code === 200) {
            setSearchUserDetails(getUserSearchCreateAPIResponse.data.search_user_details_serializer)
        } else {
            setSearchUserDetails([])
        }
    }
    
    useEffect(()=>{
        getUserSearchCreatDetails()
    }, [])

    return (
        <div className="flex w-full h-screen">
            <div className="fixed h-full custom-scroll">
            <SideBar />
            </div>

            <div className="ml-64 flex-1 overflow-y-auto">
            <Header />
            <section className="px-5 pt-5 pb-16 bg-[#F5F7FD] h-screen">
                <div className="text-blue-950 flex items-center gap-6">
                <h1 className="pr-6 text-2xl font-medium border-r">Admin Users</h1>
                <div className="flex text-sm items-center gap-3">
                    <button>
                    <SlHome />
                    </button>
                    <SlArrowRight />
                    <button>Search</button>
                    <SlArrowRight />
                    <button>Search Users</button>
                </div>
                </div>

                <section className="bg-white mt-10 py-4 rounded-lg shadow-[0px_0px_15px_0px_rgba(0,0,0,0.1)]">
                    <div className="px-5 md:px-7 pt-4 flex items-center justify-between gap-2">
                        <div className="flex items-center gap-1 font-light">
                            <p className="text-neutral-700">show</p>
                            <select
                            name="entries"
                            className="border text-sm rounded-md focus:outline-none"
                            >
                            <option value="10">10</option>
                            <option value="25">25</option>
                            <option value="50">50</option>
                            <option value="100">100</option>
                            </select>
                            <p className="text-neutral-700">entries</p>
                        </div>
                        <form className="flex items-center gap-1 font-light">
                            <label htmlFor="entries-search" className="text-neutral-700">
                            Search:
                            </label>
                            <input
                            type="text"
                            className="border-2 w-auto sm:w-40 text-sm px-2 py-[2px] rounded focus:outline-none"
                            />
                        </form>
                    </div>
                    <div className="overflow-x-auto sm:px-5 md:px-7 overflow-y-auto">
                        <table
                        className="min-w-full bg-white mt-4"
                        style={{ borderCollapse: "separate", borderSpacing: "2px" }}
                        >
                        <thead>
                            <tr>
                                <th className="px-2 sm:px-4 text-center py-2 border border-[#48ABF7] text-white text-sm font-medium tracking-wider bg-blue-400">
                                    IP ADDRESS
                                </th>
                                <th className="px-2 sm:px-4 text-center py-2 border border-[#48ABF7] text-white text-sm font-medium tracking-wider bg-blue-400">
                                    LOCATION
                                </th>
                                <th className="px-2 sm:px-4 text-start py-2 border border-[#48ABF7] text-white text-sm font-medium tracking-wider bg-blue-400">
                                    USER NAME
                                </th>
                                <th className="px-2 sm:px-4 text-start py-2 border border-[#48ABF7] text-white text-sm font-medium tracking-wider bg-blue-400">
                                    CATEGORY NAME
                                </th>
                                <th className="px-2 sm:px-4 text-start py-2 border border-[#48ABF7] text-white text-sm font-medium tracking-wider bg-blue-400">
                                    PRODUCT IMAGE
                                </th>
                                <th className="px-2 sm:px-4 text-start py-2 border border-[#48ABF7] text-white text-sm font-medium tracking-wider bg-blue-400">
                                    DATE
                                </th>
                            </tr>
                        </thead>
                        <tbody className="text-neutral-800 font-light">
                            {searchUserDetails &&
                                searchUserDetails.map((searchUser) => (
                                    <tr key={searchUser.id}>
                                        <td className={`px-4 py-6 font-normal border border-[#48ABF7] ${
                                            searchUser.ip_address ? 'text-start' : 'text-center'
                                        }`}>
                                            {searchUser.ip_address ? searchUser.ip_address : '-'}
                                        </td>
                                        <td className="px-4 py-2 border border-[#48ABF7] text-start">
                                            {searchUser.location_data ? (
                                                <ul className="space-y-1">
                                                    <li><strong>Country:</strong> {searchUser?.location_data?.country || "-"}</li>
                                                    <li><strong>County:</strong> {searchUser?.location_data?.county || "-"}</li>
                                                    <li><strong>City:</strong> {searchUser?.location_data?.city || "-"}</li>
                                                    <li><strong>Latitude:</strong> {searchUser?.location_data?.latitude || "-"}</li>
                                                    <li><strong>Longitude:</strong> {searchUser?.location_data?.longitude || "-"}</li>
                                                </ul>
                                            ) : (
                                                <p className="text-center text-gray-500">-</p>
                                            )}
                                        </td>
                                        <td className={`px-4 py-2 border border-[#48ABF7] text-start`}>
                                            {searchUser.user_name ? searchUser.user_name : '-'}
                                        </td>
                                        <td className="px-4 py-2 border border-[#48ABF7]">
                                            {searchUser.category_name}
                                        </td>
                                        {searchUser.category_menu_image ? 
                                            <td className="px-4 py-2 border border-[#48ABF7] flex justify-center items-center h-48">
                                                <img
                                                    src={searchUser.category_menu_image}
                                                    alt="ordered-product"
                                                    className="w-20 h-30 object-cover rounded"
                                                />
                                            </td>
                                            :
                                            <td className="px-4 py-2 border border-[#48ABF7]"></td>
                                        }
                                        <td className="px-4 py-2 border border-[#48ABF7]">
                                            {moment
                                            .utc(searchUser.created_at)
                                            .tz("America/New_York")
                                            .format("dddd, MMMM D, YYYY HH:mm:ss")}
                                        </td>
                                    </tr>
                            ))}
                        </tbody>
                        </table>
                    </div>

                    <div className="px-5 md:px-7 pt-6 pb-3 text-neutral-700 text-sm font-light flex items-center justify-between gap-2">
                        <p>Showing 1 to 10</p>
                        <div className="flex items-center gap-2">
                        <button className="px-3 py-1 rounded-full bg-neutral-200">
                            Previous
                        </button>
                        <p className="px-3 py-1 rounded-full bg-blue-500 text-white font-normal">
                            1
                        </p>
                        <button className="px-3 py-1 rounded-full bg-neutral-200">
                            Next
                        </button>
                        </div>
                    </div>
                </section>
            </section>
            </div>
        </div>
    );
};

export default SearchUserList;
